module.exports = __webpack_public_path__ + "static/media/communitysidebar.459fe627.png";